export const StockCheckLogo = ({ size = "default", showText = true }) => {
  const sizes = {
    small: { icon: 32, text: "text-lg" },
    default: { icon: 40, text: "text-xl" },
    large: { icon: 56, text: "text-2xl" },
    hero: { icon: 80, text: "text-4xl" },
  };

  const { icon: iconSize, text: textSize } = sizes[size] || sizes.default;

  return (
    <div className="flex items-center gap-2">
      <div className="relative">
        {/* Logo SVG */}
        <svg
          width={iconSize}
          height={iconSize}
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="logo-icon"
        >
          {/* Background box with rounded corners */}
          <rect
            x="4"
            y="4"
            width="40"
            height="40"
            rx="4"
            fill="#1E3A8A"
            className="transition-all duration-300"
          />
          
          {/* Inner gradient overlay */}
          <rect
            x="4"
            y="4"
            width="40"
            height="40"
            rx="4"
            fill="url(#blueGradient)"
          />
          
          {/* Inventory box/package shape */}
          <path
            d="M14 16H34V34H14V16Z"
            stroke="#60A5FA"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          
          {/* Box fold line */}
          <path
            d="M14 22H34"
            stroke="#60A5FA"
            strokeWidth="2"
            strokeLinecap="round"
          />
          
          {/* Vertical center line */}
          <path
            d="M24 16V22"
            stroke="#60A5FA"
            strokeWidth="2"
            strokeLinecap="round"
          />
          
          {/* Checkmark */}
          <path
            d="M18 27L22 31L30 23"
            stroke="#EF4444"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="checkmark"
          />
          
          {/* Gradient definitions */}
          <defs>
            <linearGradient
              id="blueGradient"
              x1="4"
              y1="4"
              x2="44"
              y2="44"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#1E3A8A" />
              <stop offset="1" stopColor="#3B82F6" stopOpacity="0.3" />
            </linearGradient>
          </defs>
        </svg>
        
        {/* Red accent dot */}
        <div 
          className="absolute -bottom-0.5 -right-0.5 bg-red-500 rounded-full shadow-lg shadow-red-500/40"
          style={{ 
            width: iconSize * 0.175, 
            height: iconSize * 0.175,
            minWidth: '6px',
            minHeight: '6px'
          }}
        />
      </div>
      
      {showText && (
        <div className={`font-bold ${textSize} tracking-tight`}>
          <span className="text-white">Stock</span>
          <span className="text-red-500">Check</span>
        </div>
      )}
    </div>
  );
};

// Favicon version (simplified for small sizes)
export const StockCheckFavicon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="6" fill="#1E3A8A" />
    <rect width="32" height="32" rx="6" fill="url(#faviconGradient)" />
    <path
      d="M8 10H24V24H8V10Z"
      stroke="#60A5FA"
      strokeWidth="2"
      fill="none"
    />
    <path d="M8 14H24" stroke="#60A5FA" strokeWidth="2" />
    <path d="M16 10V14" stroke="#60A5FA" strokeWidth="2" />
    <path
      d="M11 18L14 21L21 14"
      stroke="#EF4444"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="faviconGradient"
        x1="0"
        y1="0"
        x2="32"
        y2="32"
      >
        <stop stopColor="#1E3A8A" />
        <stop offset="1" stopColor="#3B82F6" stopOpacity="0.3" />
      </linearGradient>
    </defs>
  </svg>
);

export default StockCheckLogo;
